jQuery(document).ready(function() {

 
    jQuery('.menu-item.top-level-item').not('.menu-item-24,.menu-item-585').each(function () {
        var link=jQuery(this).find('.menu-item-link > a');
        var _subMenu=jQuery(this).find('.sub-menu');
        var _menuItem=jQuery('.menu-item.top-level-item').not('.menu-item-24,.menu-item-585').children('.menu-item > div');
        var item=jQuery(this);
        
       
            jQuery(item).on('click', function(event) {
                if ( jQuery( window ).width() <= 1400 ) {
                jQuery('.red').addClass('active');
                jQuery('.menu-item.top-level-item .menu-item-link > a').not('.sub-menu .menu-item-link > a').removeAttr("href");;
                _subMenu.addClass('active');
                jQuery('.sub-menu-burger-arrow').addClass('active');
                link.addClass('active');
                _menuItem.addClass('active');
                jQuery('.sub-menu.active > li').addClass('active');
                jQuery('.menu-item-24,.menu-item-585').addClass('open');
                }   
                
             });
           
    });
    
    jQuery('.sub-menu-burger-arrow').on('click', function(e){
        jQuery('.red').removeClass('active');
        jQuery('.horizontal-menu .menu .sub-menu').removeClass('active');
        jQuery('.horizontal-menu .menu li').removeClass('active');
        jQuery('.sub-menu-burger-arrow').removeClass('active');
        jQuery('.sub-menu.active > li').removeClass('active');
        jQuery('.menu-item-link > a').removeClass('active');
        jQuery('.menu-item.top-level-item').removeClass('active');
        jQuery('.menu-item > div.active').removeClass('active');
        jQuery('.menu-item-24,.menu-item-585').removeClass('open');

   
    
    });
    jQuery('.menu-burger-icon').on('click', function(e){
        jQuery('.close-menu-icon').addClass('active');
        jQuery('.menu-burger-icon').addClass('active');
        jQuery('.site-navigation .site-navigation__nav-holder').addClass('active');
        jQuery('.site-top .container').addClass('active');
        jQuery('#main').addClass('active');
        jQuery('.site-navigation').addClass('active');
        jQuery('#breadcrumbs').addClass('active');
        // jQuery('body').addClass('play');
     
     
    
    });

    jQuery('.close-menu-icon').on('click', function(e){
        jQuery('.menu-burger-icon').removeClass('active');
        jQuery('.close-menu-icon').removeClass('active');
        jQuery('.site-navigation .site-navigation__nav-holder').removeClass('active');
        jQuery('.site-navigation').removeClass('active');
        jQuery('.site-top .container').removeClass('active');
        jQuery('#main').removeClass('active');
        jQuery('#breadcrumbs').removeClass('active');
        // jQuery('body').removeClass('play');
     
    });
    
}); 
